<template>
	<nav id="New-Main-Navigation">
		<div class="desktop navItems">
            <div class="logo verticalAlign"><div to="/" class="logoLink"><div class="logoImg"></div></div></div>
			<div class="items">
				<!-- <router-link v-for="(link, index) in filteredLinks" :to="link.path" :key="index" class="verticalAlign item desktop"><div class="verticalAlign"><p>{{link.title}}</p></div></router-link>
                <router-link v-if="isAuthenticated" to="/login" class="verticalAlign item desktop"><div class="verticalAlign"><p>LOGOUT</p></div></router-link> -->
                <a href="#" v-if="isAuthenticated" class="menuBtn mobileShow item" v-on:click.prevent="toggleMobileMenu"><div class="verticalAlign"><p>MENU</p></div></a>
			</div>
			<!-- <router-link to="/">HOME</router-link>
			<router-link to="/overview">OVERVIEW</router-link>
			<router-link to="/registration">REGISTRATION</router-link>
			<router-link to="/faq">FAQ</router-link> -->
		</div>
        <transition name="grow" mode="out-in">
            <div v-if="menuOpen" class="mobileNav mobileShow">
                <!-- <router-link v-for="(link, index) in filteredLinks" :to="link.path" :key="index" class="verticalAlign"><div class="verticalAlign"><p>{{link.title}}</p></div></router-link>
                <router-link v-if="isAuthenticated" to="/login" class="verticalAlign"><div class="verticalAlign"><p>LOGOUT</p></div></router-link> -->
            </div>
        </transition>

	</nav>
</template>

<script>
	export default {
		name: 'navBar',
		data() {
			return {
				isMobile: true,
				menuOpen: false,
				links: [
					{
						title: 'HOME',
						path: '/user',
						show: ()=>this.isAuthenticated
					},
					{
						title: 'ADMIN',
						path: '/admin',
						show: ()=>this.isAdmin
					},
					// {
					// 	title: 'CONTACT',
					// 	path: '/contact'
					//},

				]

			}
		},
		methods: {
			logout(){
				this.$store.dispatch('logout')
					.then(()=>{
						location.reload();
					});
			},
			toggleMobileMenu() {
				this.menuOpen = !this.menuOpen;
			},
			closeMenu() {
				this.menuOpen = false;
			}
		},
		computed: {
			filteredLinks() {
				return this.links.filter(link => link.show());
			},
			isAdmin() {
				return true;
			},
			isAuthenticated() {
				return true
			}
			// hasUserId() {
			// 	return this.$store.state.user.id ? true : false;
			// },
			// isSignedIn() {
			// 	return this.$store.state.accessToken ? true : false;
			// }
		}
	}
</script>

<style lang="scss" scoped>
    .verticalAlign {
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;
    }
    .desktop {
        // @media (max-width: 768px) {
        //     display: none;
        // }
    }
    .mobileShow {
		display: none;
		
		p {
			font-size: 1.3rem;
		}
        // @media (max-width: 768px) {
        //     display: block;
        // }
    }
    .mobileNav {
        // position: absolute;
        // top: 50px;
        // left: 0;
        width: 100%;
        height: auto;
        //background:white;
    }

    .grow-enter-active, .grow-leave-active {
        transition: all 0.5s;
    }
    .grow-enter, .grow-leave-to {
        transform: translateX(-100%);
    }
	#New-Main-Navigation {
		z-index: 999;
		display: block;
		position: absolute;
        top: 0;
        left: 0;
        width:100%;
        background-color: $darkblue;
	}

	.primary-navigation-bar {
		border-bottom: 1px solid #ddd;
		width: 100%;
		height: $navHeight;
		display: block;
		//background-color: #fff;
		position: fixed;
		top: 0;
	}
	.navInfo {
		height: 81px;
		//background-color: white;
    }
    
    .logo {
        width: 280px;
        // height: 46px;
        // background-image: url('../assets/logo.png');
        // background-size: cover;
        // background-position: center;
        // background-repeat: no-repeat;
        margin-left: 4rem;
        // background-color: black;

        a {
            height: 100%;
        }

        .logoLink div{
            width: 100%;
            height: 30px;
            background-image: url('../assets/jd_logo_white.png');
			background-size: contain;
			background-repeat: no-repeat;
			

		}
		
		@media (max-width: 550px) {
			margin-left: 15px;
		}
    }

	.logo-block {
		width: 100%;
		left: 0;
		right: 0;
		position: absolute;
		display: inline-block;
		text-align: center;
	}

	.logo-container {
		/* width: 81px; */
		height: 81px;
		margin: 0 auto;
		padding: 12px;
		float: left;
	}

	.right-menu-block {
		float: right;
		text-align: right;
	}

	.right-menu-title {
		font-size: 16px;
		padding: 25px 0;
    display: inline-block;
    font-size: 18px;
    line-height: 27px;
    cursor: pointer;
    position: relative;
    margin-right: 30px;
}

	.right-menu-title a {
		text-decoration: none;
		color: #161618;
		border-bottom: 0;
		padding-top: 25px;
		padding-bottom: 30px;
	}

	.navItems {
		//background-color: white;
		height: $navHeight;
        display: flex;
        z-index: 9999;
        border-bottom: $gold 3px solid;

        // .logo {
        //     width: 50px;
        // }
	}
	/* nav {
	  padding: 30px;
	}

	nav a {
	  font-weight: bold;
	  color: #2c3e50;
	}

	nav a.router-link-exact-active {
	  color: #42b983;
	} */
	.mobile {
		display: flex;
		width: 100%;
		flex-direction: column;
		//background-color: #fafafa;
	}
	.mobileItem {
		font-size: 16px;
		padding: 25px 0;
		/* display: inline-block; */
		font-size: 18px;
		line-height: 27px;
		cursor: pointer;
		text-align: center;
		/* position: relative; */
		/* margin-right: 30px; */
	}
	.mobileItem a {
		text-decoration: none;
		color: #161618;
		border-bottom: 0;
		padding-top: 25px;
		padding-bottom: 30px;
	}
	.mobile .right-menu-title {
		width: 100%;
	}
	.mobileMenu {
		height: 100%;
		margin-top: 5px;
	}
	.menu {
	    background-color: rgba(0,0,0,0.7);
	    font-size: 16px;
	    margin-top: -62px;
	    z-index: 1;
	    padding: 20px;
	}
	.menu a {
	    color: #ffffff;
	    padding: 20px;
	    text-decoration: none;
	}

	.items {
		/* max-width: 1200px; */
		width: 100%;
		display: flex;
		justify-content: flex-end;
		height: 100%;
	}
    a {
        text-decoration: none;
        color: $grey;
    }

	a p{
        width: 65px;
        text-align: left;
		border-bottom: 2px $grey solid;
        font-size: 12px;
	}
    .mobileNav a {
		width: 100%;
		height: 3rem;
        display: flex;
        justify-content: center;
    }
    .mobileNav p {
        width: auto;
        min-width: 65px;
        font-size: 16px;
        margin: 0 auto;
        text-align: center;
    }
    a p:hover {
        border-bottom: 2px $gold solid;
    }

	p {
		margin: 0;
	}
	.item {
		padding: 0 15px;
	}

	// .grow-enter-active, .grow-leave-active {
	// 	transition: all 1s;
	// }
	// .grow-enter, .grow-leave-to {
	// 	transform: translateX(-100%);
	// }
	.mobileMenuIcon {
		display: none;
	}
	.mobileMenu {
		display: none;
	}
	.signIn {
		width: 75px;
	}
	@media only screen and (max-width: 1200px) {
		.mobileMenuIcon {
			display: block;
		}
		.mobileMenu {
			display: block;
		}
		.desktopMenu {
			display: none;
		}
	}
</style>
